import angular from 'angular';

angular.module('cloudX').directive('cxContactSelect', [
  function() {
    return {
      restrict: 'E',
      template: require('./contactSelect.html'),
      scope: {
        contactReference: '=data',
        relId: '@',
        save: '&',
        setIfOne: '@',
        disabled: '=?',
      },
      controller: [
        '$scope',
        'relBindSvc',
        '$filter',
        function($scope, relBindSvc, $filter) {
          // we add the option of setting the attribute setIfOne to true for when used in form (eg new commSetting) that will be saved.
          // in that case, when only one option is available, that one is set by default.
          $scope.setIfOne = $scope.setIfOne === 'true';

          var relation = relBindSvc.relations[$scope.relId];
          $scope.contacts = relation[relation.linksSectionId].value;

          $scope.emptyArray1 = [];
          $scope.emptyArray2 = [];
          $scope.removeDefaultOption = function() {
            $scope.emptyArray1 = [];
            $scope.emptyArray2 = [];
          };
          if (
            !$scope.contactReference.valueId ||
            $scope.contactReference.valueId === '00000000-0000-0000-0000-000000000000'
          ) {
            var contactsFrom = $filter('filter')($scope.contacts, {
              from: $scope.relId,
            });
            if (contactsFrom.length === 1 && $scope.setIfOne) {
              $scope.contactReference.valueId = contactsFrom[0].id;
            } else {
              $scope.emptyString1 = $filter('translate')('No contacts entered yet');
              $scope.emptyString2 = $filter('translate')('Select a contact');
              $scope.emptyArray1 = [
                {
                  target: {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: $scope.emptyString1,
                  },
                },
              ];
              $scope.emptyArray2 = [
                {
                  target: {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: $scope.emptyString2,
                  },
                },
              ];
            }
          }
        },
      ],
    };
  },
]);
